// DoF headshots. The image files live in public/avatars/ (Jamie supplies them).
// This list is the single source of truth for what the profile creator offers;
// add, remove or rename entries to match the files on disk. A tile whose image
// is missing falls back to a monogram, so the picker always looks intact.
// Images are 512x512 JPEGs (originals kept in groundworkfc/avatars-originals/).

export const AVATARS = [
  { id: 'm1', src: '/avatars/m1.jpg', gender: 'male' },
  { id: 'm2', src: '/avatars/m2.jpg', gender: 'male' },
  { id: 'm3', src: '/avatars/m3.jpg', gender: 'male' },
  { id: 'm4', src: '/avatars/m4.jpg', gender: 'male' },
  { id: 'm5', src: '/avatars/m5.jpg', gender: 'male' },
  { id: 'm6', src: '/avatars/m6.jpg', gender: 'male' },
  { id: 'm7', src: '/avatars/m7.jpg', gender: 'male' },
  { id: 'm8', src: '/avatars/m8.jpg', gender: 'male' },
  { id: 'm9', src: '/avatars/m9.jpg', gender: 'male' },
  { id: 'm10', src: '/avatars/m10.jpg', gender: 'male' },
  { id: 'f1', src: '/avatars/f1.jpg', gender: 'female' },
  { id: 'f2', src: '/avatars/f2.jpg', gender: 'female' },
  { id: 'f3', src: '/avatars/f3.jpg', gender: 'female' },
  { id: 'f4', src: '/avatars/f4.jpg', gender: 'female' },
  { id: 'f5', src: '/avatars/f5.jpg', gender: 'female' },
  { id: 'f6', src: '/avatars/f6.jpg', gender: 'female' },
  { id: 'f7', src: '/avatars/f7.jpg', gender: 'female' },
  { id: 'f8', src: '/avatars/f8.jpg', gender: 'female' },
  { id: 'f9', src: '/avatars/f9.jpg', gender: 'female' },
  { id: 'f10', src: '/avatars/f10.jpg', gender: 'female' },
];

export function avatarsFor(gender) {
  if (gender === 'male' || gender === 'female') {
    return AVATARS.filter((a) => a.gender === gender);
  }
  return AVATARS;
}

export function avatarSrc(id) {
  const a = AVATARS.find((x) => x.id === id);
  return a ? a.src : null;
}

export const GENDERS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'unspecified', label: 'Rather not say' },
];
